export default function HeroHome() {
    if ($('.v-accueil__header').length > 0) {

        const home = {
            wrapper: $('.v-accueil__header'),
            content: $('.v-accueil__header .container'),
            about: $('.v-accueil__apropos'),
        }

        TweenMax.fromTo(home.wrapper, .8, {
            opacity: 0
        }, {
            opacity: 1,
            ease: Power3.easeInOut
        });

        TweenMax.fromTo(home.content, .8, {
            x: '-100%',
        }, {
            x: '0%',
            ease: Power3.easeInOut,
        })

        TweenMax.fromTo(home.about, .8, {
            y: '100%',
        }, {
            y: '0%',
            ease: Power3.easeInOut,
        })
    }
}

HeroHome();
